import { render, staticRenderFns } from "./TabBackground.vue?vue&type=template&id=64ca5a84&scoped=true&"
import script from "./TabBackground.vue?vue&type=script&lang=js&"
export * from "./TabBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca5a84",
  null
  
)

export default component.exports